import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stock-accordion-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="bg-white dark:bg-gray-800 rounded-lg overflow-hidden animate-pulse">
      <!-- Collapsed header rows only — matches p-accordion-header / app-company-display layout -->
      <div *ngFor="let item of skeletonRows(); trackBy: trackByIndex" class="border-b border-gray-200 dark:border-gray-700 last:border-b-0">
        <div class="px-4 py-4 flex items-center justify-between">
          <!-- Logo circle + ticker + company name -->
          <div class="flex items-center space-x-3">
            <div class="h-10 w-10 bg-gray-200 dark:bg-gray-600 rounded-full flex-shrink-0"></div>
            <div class="flex flex-col gap-1.5">
              <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-14"></div>
              <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-36"></div>
            </div>
          </div>
          <!-- Chevron placeholder -->
          <div class="h-4 w-4 bg-gray-200 dark:bg-gray-600 rounded flex-shrink-0"></div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .animate-pulse {
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: .5;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockAccordionSkeletonComponent {
  // Input for number of skeleton rows to display
  rows = input<number>(5);

  // Computed signal for skeleton rows array — stable reference unless rows() changes
  skeletonRows = computed(() => Array.from({ length: this.rows() }, (_, i) => i));

  // TrackBy function for performance
  trackByIndex(index: number): number {
    return index;
  }
}
